import { render, staticRenderFns } from "./DrivewealthNavigation.vue?vue&type=template&id=c4c06ce4&scoped=true"
import script from "./DrivewealthNavigation.vue?vue&type=script&lang=ts"
export * from "./DrivewealthNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c06ce4",
  null
  
)

export default component.exports